import { UseFormMethods, useWatch } from 'react-hook-form';
import { Collapse, Typography } from '@material-ui/core';
import React from 'react';
import { FormSectionInfo } from '../../../../../form/components';
import { RHFRadioGroup } from '../../../../../../packages/react-hook-form/radio-group/radio-group';
import { signAuthorities } from '../../representatives-utils';
import { RadioLabelled } from '../../../../../../packages/radio-labelled';
import { InputText } from '../../../../../input';
import { SignAuthority } from '../../../../../../global/entities/BuyOrder';
import { objectKeys } from '../../../../../../utils/object-keys';
import { FormSectionContainer } from '../../../../../form/components/form-section-container/form-section-container';

export const RepresentativesSignAuthorityInput = ({
  control,
  register,
  errors,
  signAuthorityField,
}: Pick<UseFormMethods, 'control' | 'register' | 'errors'> & {
  signAuthorityField: string;
}) => {
  const signAuthority = useWatch({ control, name: signAuthorityField });

  return (
    <React.Fragment>
      <FormSectionInfo.InfoBoxTitled title="Firmateckning">
        <Typography>
          Styrelsen har alltid rätt att teckna firman enligt lag. Om annan
          firmateckning önskas anger du det här. Observera att "firman tecknas
          av styrelsen" innebär att alla styrelseledamöter måste skriva på för
          bolagets räkning.
        </Typography>
      </FormSectionInfo.InfoBoxTitled>

      <FormSectionContainer>
        <RHFRadioGroup
          label="Firmateckning *"
          control={control}
          name="signAuthority"
          defaultValue={signAuthorities[SignAuthority.AB1]}
        >
          {objectKeys(signAuthorities).map((key) => (
            <RadioLabelled value={key} label={signAuthorities[key]} key={key} />
          ))}
        </RHFRadioGroup>

        <Collapse in={signAuthority === SignAuthority.ABX}>
          <InputText
            ref={register}
            errors={errors}
            multiline
            name="signAuthorityUserDefined"
          />
        </Collapse>
      </FormSectionContainer>
    </React.Fragment>
  );
};
